<template>
  <div class="bank-account-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-data"></i> Bank Account Report</span>
      </div>

      <el-form :inline="true" :model="query" size="medium">
        <el-form-item label="Currency">
          <el-select v-loading="loadingCurrency" v-model="query.currency" placeholder="Currenct" style="width:100px">
            <el-option value="" label="All"></el-option>
            <el-option v-for="item in currencys" :key="item.uid" :value="item.currency" :label="item.currency.toUpperCase()"></el-option>

          </el-select>
        </el-form-item>
        <!-- <el-form-item label="Month">
          <el-select v-model="query.month" placeholder="Month" style="width:100px">
            <el-option
                v-for="item in month_option"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Year">
          <el-select v-model="query.year" placeholder="Year" style="width:100px">
            <el-option
                v-for="item in year_option"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="getBankaccountData()">Query</el-button>
          <el-button type="success" icon="el-icon-download" @click="Export()">Export</el-button>
        </el-form-item>
      </el-form>

      <el-table 
          v-loading="loading" 
          :data="tableData" 
          border 
       
          :row-class-name="tableRowStatus">

          <el-table-column prop="created_date" label="Create Date" width="120" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="created_time" label="Time" width="120" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="status" label="Status" width="100" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="member_code" label="Member Code" width="120" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="bankholderID" label="BankholderID" width="180" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="project_name" label="Project" width="300" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="customer_name" label="Name" width="300" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="currency" label="Currency" width="100" header-align="center" align="center" ></el-table-column>
          <el-table-column prop="company_name" label="Agent Name" width="300" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="create_user" label="Authoirse Account" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="region" label="Region" width="120" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="suspend" label="Suspend Number" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="monthlycharge_suspend" label="Montyly Charge Suspend"  width="200" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="complianceORfraud_suspend" label="Compliance/Fraud Suspend"  width="200" header-align="center" align="center"> </el-table-column>
        </el-table>

        <div class="pagination-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 30, 50, 100, 200]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper, sizes, total"
            :total="total">
          </el-pagination>
        </div>

    </el-card>
  </div>
</template>

<script>
import { getCurrencyList } from '@/api/currency'
import { getBankaccount, getBankaccountExcelFile } from "@/api/report";
import { currentYear, currentMonth , padStart, currencyFormat} from '@/utils'
export default {
  props:{
    project: String
  },
  watch: {
      project(val, old) {
        this.query.project_uid = val;
        this.getCurrencyList()
        this.getBankaccountData();
      }
  },
  computed: {
    roleSuperAdmin() {
      return this.roleAuth([this.role.spadmin]);
    },
    rolePrice(){
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    }
  },
  data(){
    return {
      query: {
        project_uid: "",
        currency : "",
        month: currentMonth(),
        year: currentYear()
      },
      month_option: [],
      year_option: [],
      dataReport: [],
      tableData: [],
      loading: false,
      loadingCurrency: false,
      currentPage: 1,
      pageSize: 50,
      total: 0,
      sumData : null,
      currencys: [],

    }
  },
  methods:{
    getBankaccountData(){
      this.loading = true
      this.query.project_uid = this.project || ""
      getBankaccount(this.query).then(({result, data})=>{
        this.loading = false
        if(result){
          this.dataReport = data
          this.total = data.length
          this.Pagination()
        }
      })
    },
    getCurrencyList(){
      if(!this.project) return;
      this.loadingCurrency = true;
      getCurrencyList(this.project).then(({result, data})=>{
        this.loadingCurrency = false
        if (result) {
          this.currencys = data;
          this.query.currency = ""
        }
      })
    },
    Pagination(){
      this.tableData = this.dataReport.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    Export(){
      getBankaccountExcelFile(this.query)
    },
    tableRowStatus({row}) {
      return row.bank_status;
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.Pagination()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.Pagination()
    },
    dropdownMonthYear() {
      for (let m = 1; m <= 12; m++) {
        this.month_option.push({ value: padStart(m, 2) });
      }

      for (let y = (currentYear() - 5); y <= currentYear(); y++) {
        this.year_option.push({ value: y.toString() });
      }
    },
    currencyFormat(num = 0, currency){
      return currencyFormat(num, currency)
    }
  },
  created(){
    this.getCurrencyList()
    // this.getBankaccountData()
    this.dropdownMonthYear()
  }
}
</script>

<style lang="scss">
.bank-account-report{
  .el-table .closed {
    background: #ffdede;
  }

  .el-table .suspended {
    background: #f3f3f3;
  }

  .pagination-block{
    margin-top: 10px;
  }

}
</style>